const common = require("lib/labels/_common");

// Home.backoffice.profiles

module.exports = {
  profilesList: {
    title: {
      en: "Profiles",
      fr: "Profils"
    },
    title_delete_check: common.title_delete_check,
    content_delete_check: common.content_delete_check,
    no: common.no,
    yes: common.yes,
    edit: common.edit,
    remove: common.remove
  },
  profileForm: {
    stepTitle: {
      en: "Profile",
      fr: "Profil"
    },
    title: {
      edition: {
        en: "Profile edition",
        fr: "Edition de profil"
      },
      creation: {
        en: "Profile creation",
        fr: "Création de profil"
      }
    },
    name: {
      label: common.name,
      text: {
        en: "Give a profile name",
        fr: "Donnez un nom au profil"
      }
    },
    admin: {
      en: "Administrator",
      fr: "Administrateur"
    },
    manager: {
      en: "Manager",
      fr: "Manager"
    },
    user: {
      en: "User",
      fr: "Utilisateur"
    },
    permissions: common.permissions,
    selectAll: {
      en: "Select all",
      fr: "Tout sélectionner"
    },
    unselectAll: {
      en: "Unselect all",
      fr: "Tout désélectionner"
    }
  }
};
